// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"41f97191","23":"9028c4d4","219":"526ae25d","362":"90e164cb","595":"d8e8d3d6","853":"f0e0dbed"}[chunkId] + ".chunk.js";
};